module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_2-d3aa86e20c028bf8aa3a9139a8cd8889.jpg";